import { render } from "./SettingsView.vue?vue&type=template&id=ad43ab4c&scoped=true&ts=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=ad43ab4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad43ab4c"]])

export default __exports__